<template>
  <div class="grouped-config-panel">
    <div class="text-white font-semibold text-sm mb-4 flex items-center justify-between">
      <span>🎯 Configuração por Grupos</span>
    </div>

    <!-- Template Management Section -->
    <div class="template-section mb-4 p-3 bg-white/5 rounded-lg border border-white/10">
      <div class="text-white text-xs font-medium mb-2 flex items-center gap-2">
        <span>📦 Templates</span>
        <span class="text-white/50 text-[10px]">({{ savedTemplates.length }} salvos)</span>
      </div>
      
      <div class="flex gap-2 mb-3">
        <button
          @click="$emit('save-template')"
          class="flex-1 px-3 py-2 bg-blue-500/80 hover:bg-blue-500 text-white text-xs rounded-lg transition-colors flex items-center justify-center gap-1"
        >
          💾 Salvar Atual
        </button>
        <button
          @click="$emit('load-template')"
          class="flex-1 px-3 py-2 bg-green-500/80 hover:bg-green-500 text-white text-xs rounded-lg transition-colors flex items-center justify-center gap-1"
        >
          📂 Carregar
        </button>
        <label class="flex-1 px-3 py-2 bg-purple-500/80 hover:bg-purple-500 text-white text-xs rounded-lg transition-colors flex items-center justify-center gap-1 cursor-pointer">
          📥 Importar
          <input
            type="file"
            accept=".json"
            @change="$emit('import-template', $event)"
            class="hidden"
          />
        </label>
      </div>

      <!-- Quick Templates List -->
      <div v-if="savedTemplates.length > 0" class="space-y-1">
        <div
          v-for="template in savedTemplates.slice(0, 3)"
          :key="template.id"
          class="flex items-center gap-2 p-2 bg-white/5 rounded hover:bg-white/10 transition-colors"
        >
          <div class="flex-1 min-w-0">
            <div class="text-white text-xs font-medium truncate">{{ template.name }}</div>
            <div class="text-white/50 text-[10px]">{{ formatDate(template.createdAt) }}</div>
          </div>
          <button
            @click="$emit('load-template-direct', template)"
            class="px-2 py-1 bg-green-500/50 hover:bg-green-500 text-white text-[10px] rounded transition-colors"
            title="Carregar este template"
          >
            Usar
          </button>
        </div>
        <button
          v-if="savedTemplates.length > 3"
          @click="$emit('load-template')"
          class="w-full px-2 py-1 text-white/70 hover:text-white text-[10px] text-center"
        >
          Ver todos ({{ savedTemplates.length }})...
        </button>
      </div>
    </div>

    <div class="space-y-3">
      <!-- Grupo: Textos Customizados -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('globalTexts')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.globalTexts.icon }}</span>
            <span class="font-medium">{{ groups.globalTexts.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('globalTexts')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.globalTexts.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.globalTexts.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.globalTexts ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.globalTexts" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">📱 Mobile</span>
              <span class="badge">💻 Tablet</span>
              <span class="badge">🖥️ Desktop</span>
              <span class="badge">🌙 Dark</span>
              <span class="badge">☀️ Light</span>
            </div>
          </div>

          <div class="space-y-3">
            <!-- Texto 1 - Titulo Pré Login -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Pré Login - Título</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.preLoginTitle"
                @input="updateGroupValue('globalTexts', 'customTexts.preLoginTitle', $event.target.value)"
                placeholder="Olá, Seja Bem-vindo!"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 2 - Subtitulo Pré Login -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Pré Login - Subtítulo</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.preLoginSubtitle"
                @input="updateGroupValue('globalTexts', 'customTexts.preLoginSubtitle', $event.target.value)"
                placeholder="Gerencie suas operações com segurança"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 3 - Titulo Form -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Login - Título</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.formTitle"
                @input="updateGroupValue('globalTexts', 'customTexts.formTitle', $event.target.value)"
                placeholder="Acesse Sua Conta"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 4 - Subtitulo Form -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Login - Subtítulo</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.formSubtitle"
                @input="updateGroupValue('globalTexts', 'customTexts.formSubtitle', $event.target.value)"
                placeholder="Insira seus dados para continuar."
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 5 - Titulo Token -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Token - Título</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.tokenTitle"
                @input="updateGroupValue('globalTexts', 'customTexts.tokenTitle', $event.target.value)"
                placeholder="Chave de acesso"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 6 - Subtitulo Token -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Token - Subtítulo</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.tokenSubtitle"
                @input="updateGroupValue('globalTexts', 'customTexts.tokenSubtitle', $event.target.value)"
                placeholder="Para continuar, digite o código que acabamos de enviar para o seu e-mail."
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 7 - Titulo Recuperar Senha -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Recuperar Senha - Título</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.recoverTitle"
                @input="updateGroupValue('globalTexts', 'customTexts.recoverTitle', $event.target.value)"
                placeholder="Recuperar senha"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 8 - Subtitulo Recuperar Senha -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Recuperar Senha - Subtítulo</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.recoverSubtitle"
                @input="updateGroupValue('globalTexts', 'customTexts.recoverSubtitle', $event.target.value)"
                placeholder="Digite seus dados para recuperar o acesso."
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 9 - Titulo Cadastro -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Cadastro - Título</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.cadastroTitle"
                @input="updateGroupValue('globalTexts', 'customTexts.cadastroTitle', $event.target.value)"
                placeholder="Cadastre-se"
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>

            <!-- Texto 10 - Subtitulo Cadastro -->
            <div class="p-3 bg-white/5 rounded-lg">
              <label class="text-white text-xs font-medium block mb-2">Cadastro - Subtítulo</label>
              <input
                type="text"
                :value="groups.globalTexts.values.customTexts.cadastroSubtitle"
                @input="updateGroupValue('globalTexts', 'customTexts.cadastroSubtitle', $event.target.value)"
                placeholder="Preencha seus dados para criar sua conta."
                class="w-full px-3 py-2 bg-white/10 text-white text-sm rounded border border-white/20 placeholder-white/40"
              />
            </div>
          </div>

          <button @click="applyGroup('globalTexts')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Grupo: Layout Mobile -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('mobileLayout')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.mobileLayout.icon }}</span>
            <span class="font-medium">{{ groups.mobileLayout.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('mobileLayout')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.mobileLayout.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.mobileLayout.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.mobileLayout ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.mobileLayout" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">📱 Mobile</span>
              <span class="badge">🌙 Dark</span>
              <span class="badge">☀️ Light</span>
            </div>
          </div>

          <div class="space-y-3">
            <div>
              <label class="text-white text-xs block mb-1">Largura Máxima: {{ parseInt(groups.mobileLayout.values.maxWidth) }}px</label>
              <input
                type="range"
                :value="parseInt(groups.mobileLayout.values.maxWidth)"
                @input="updateGroupValue('mobileLayout', 'maxWidth', $event.target.value + 'px')"
                min="200"
                max="800"
                step="50"
                class="w-full"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-2">Alinhamento</label>
              <div class="flex gap-2">
                <button
                  @click="updateGroupValue('mobileLayout', 'alignment', 'left')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.mobileLayout.values.alignment === 'left'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  ← Esquerda
                </button>
                <button
                  @click="updateGroupValue('mobileLayout', 'alignment', 'center')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.mobileLayout.values.alignment === 'center'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Centro
                </button>
                <button
                  @click="updateGroupValue('mobileLayout', 'alignment', 'right')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.mobileLayout.values.alignment === 'right'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Direita →
                </button>
              </div>
            </div>
          </div>

          <button @click="applyGroup('mobileLayout')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Grupo: Layout Tablet -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('tabletLayout')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.tabletLayout.icon }}</span>
            <span class="font-medium">{{ groups.tabletLayout.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('tabletLayout')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.tabletLayout.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.tabletLayout.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.tabletLayout ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.tabletLayout" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">💻 Tablet</span>
              <span class="badge">🌙 Dark</span>
              <span class="badge">☀️ Light</span>
            </div>
          </div>

          <div class="space-y-3">
            <div>
              <label class="text-white text-xs block mb-1">Largura Máxima: {{ parseInt(groups.tabletLayout.values.maxWidth) }}px</label>
              <input
                type="range"
                :value="parseInt(groups.tabletLayout.values.maxWidth)"
                @input="updateGroupValue('tabletLayout', 'maxWidth', $event.target.value + 'px')"
                min="400"
                max="1200"
                step="50"
                class="w-full"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-2">Alinhamento</label>
              <div class="flex gap-2">
                <button
                  @click="updateGroupValue('tabletLayout', 'alignment', 'left')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.tabletLayout.values.alignment === 'left'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  ← Esquerda
                </button>
                <button
                  @click="updateGroupValue('tabletLayout', 'alignment', 'center')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.tabletLayout.values.alignment === 'center'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Centro
                </button>
                <button
                  @click="updateGroupValue('tabletLayout', 'alignment', 'right')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.tabletLayout.values.alignment === 'right'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Direita →
                </button>
              </div>
            </div>
          </div>

          <button @click="applyGroup('tabletLayout')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Grupo: Layout Desktop -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('desktopLayout')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.desktopLayout.icon }}</span>
            <span class="font-medium">{{ groups.desktopLayout.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('desktopLayout')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.desktopLayout.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.desktopLayout.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.desktopLayout ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.desktopLayout" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">🖥️ Desktop</span>
              <span class="badge">🌙 Dark</span>
              <span class="badge">☀️ Light</span>
            </div>
          </div>

          <div class="space-y-3">
            <div>
              <label class="text-white text-xs block mb-1">Largura: {{ groups.desktopLayout.values.width }}</label>
              <input
                type="range"
                :value="parseInt(groups.desktopLayout.values.width)"
                @input="updateGroupValue('desktopLayout', 'width', $event.target.value + 'px')"
                min="400"
                max="2000"
                step="50"
                class="w-full"
              />
              <div class="flex justify-between text-[10px] text-white/50 mt-1">
                <span>400px</span>
                <span>2000px</span>
              </div>
            </div>

            <div>
              <label class="text-white text-xs block mb-1">Largura Mínima: {{ parseInt(groups.desktopLayout.values.minWidth) }}px</label>
              <input
                type="range"
                :value="parseInt(groups.desktopLayout.values.minWidth)"
                @input="updateGroupValue('desktopLayout', 'minWidth', $event.target.value + 'px')"
                min="400"
                max="1200"
                step="50"
                class="w-full"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-1">Largura Máxima: {{ parseInt(groups.desktopLayout.values.maxWidth) }}px</label>
              <input
                type="range"
                :value="parseInt(groups.desktopLayout.values.maxWidth)"
                @input="updateGroupValue('desktopLayout', 'maxWidth', $event.target.value + 'px')"
                min="500"
                max="1600"
                step="50"
                class="w-full"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-1">Margem/Distância da Borda: {{ parseFloat(groups.desktopLayout.values.margin || 0) }}rem</label>
              <input
                type="range"
                :value="parseFloat(groups.desktopLayout.values.margin || 0)"
                @input="updateGroupValue('desktopLayout', 'margin', $event.target.value + 'rem')"
                min="0"
                max="20"
                step="0.5"
                class="w-full"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-2">Alinhamento</label>
              <div class="flex gap-2">
                <button
                  @click="updateGroupValue('desktopLayout', 'alignment', 'left')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.desktopLayout.values.alignment === 'left'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  ← Esquerda
                </button>
                <button
                  @click="updateGroupValue('desktopLayout', 'alignment', 'center')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.desktopLayout.values.alignment === 'center'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Centro
                </button>
                <button
                  @click="updateGroupValue('desktopLayout', 'alignment', 'right')"
                  :class="[
                    'flex-1 py-2 px-3 rounded-lg text-xs transition-colors',
                    groups.desktopLayout.values.alignment === 'right'
                      ? 'bg-white/25 text-white'
                      : 'bg-white/10 text-white/70'
                  ]"
                >
                  Direita →
                </button>
              </div>
            </div>
          </div>

          <button @click="applyGroup('desktopLayout')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Grupo: Aparência Dark -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('darkMode')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.darkMode.icon }}</span>
            <span class="font-medium">{{ groups.darkMode.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('darkMode')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.darkMode.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.darkMode.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.darkMode ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.darkMode" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">📱 Mobile</span>
              <span class="badge">💻 Tablet</span>
              <span class="badge">🖥️ Desktop</span>
              <span class="badge">🌙 Dark</span>
            </div>
          </div>

          <div class="space-y-3">
            <div class="color-field">
              <label>Cor de Fundo</label>
              <input
                type="color"
                :value="groups.darkMode.values.backgroundColor"
                @input="updateGroupValue('darkMode', 'backgroundColor', $event.target.value)"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-1">Opacidade: {{ groups.darkMode.values.opacity }}%</label>
              <input
                type="range"
                :value="groups.darkMode.values.opacity"
                @input="updateGroupValue('darkMode', 'opacity', parseInt($event.target.value))"
                min="0"
                max="100"
                step="5"
                class="w-full"
              />
            </div>

            <div class="flex items-center justify-between">
              <label class="text-white text-xs">Inverter Logo</label>
              <button
                @click="updateGroupValue('darkMode', 'logoInvert', !groups.darkMode.values.logoInvert)"
                :class="[
                  'w-10 h-5 rounded-full transition-colors',
                  groups.darkMode.values.logoInvert ? 'bg-blue-500' : 'bg-white/20'
                ]"
              >
                <div
                  :class="[
                    'w-4 h-4 bg-white rounded-full transition-transform',
                    groups.darkMode.values.logoInvert ? 'translate-x-5' : 'translate-x-0.5'
                  ]"
                ></div>
              </button>
            </div>

            <div class="border-t border-white/10 pt-3 mt-3">
              <div class="text-white text-xs font-medium mb-2">🎨 Cores</div>
              
              <div class="space-y-2">
                <div class="color-field">
                  <label>Cor do Botão (Tipo 1)</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.buttonColorType1"
                    @input="updateGroupValue('darkMode', 'buttonColorType1', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Botão (Tipo 2)</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.buttonColorType2"
                    @input="updateGroupValue('darkMode', 'buttonColorType2', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto dos Botões</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.buttonTextColor"
                    @input="updateGroupValue('darkMode', 'buttonTextColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do texto do botão hover</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.buttonHoverColor"
                    @input="updateGroupValue('darkMode', 'buttonHoverColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.textColor"
                    @input="updateGroupValue('darkMode', 'textColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto dos Inputs</label>
                  <input
                    type="color"
                    :value="groups.darkMode.values.inputTextColor"
                    @input="updateGroupValue('darkMode', 'inputTextColor', $event.target.value)"
                  />
                </div>
              </div>
            </div>
          </div>

          <button @click="applyGroup('darkMode')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Grupo: Aparência Light -->
      <div class="group-card">
        <div class="group-header" @click="toggleGroup('lightMode')">
          <div class="flex items-center gap-2">
            <span class="text-xl">{{ groups.lightMode.icon }}</span>
            <span class="font-medium">{{ groups.lightMode.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <button
              @click.stop="toggleGroupEnabled('lightMode')"
              :class="[
                'w-10 h-5 rounded-full transition-colors',
                groups.lightMode.enabled ? 'bg-blue-500' : 'bg-white/20'
              ]"
            >
              <div
                :class="[
                  'w-4 h-4 bg-white rounded-full transition-transform',
                  groups.lightMode.enabled ? 'translate-x-5' : 'translate-x-0.5'
                ]"
              ></div>
            </button>
            <span class="text-white/50">{{ expandedGroups.lightMode ? '▼' : '▶' }}</span>
          </div>
        </div>
        
        <div v-if="expandedGroups.lightMode" class="group-content">
          <div class="apply-to-section">
            <div class="text-xs text-white/70 mb-2">Aplicar para:</div>
            <div class="flex gap-2 flex-wrap">
              <span class="badge">📱 Mobile</span>
              <span class="badge">💻 Tablet</span>
              <span class="badge">🖥️ Desktop</span>
              <span class="badge">☀️ Light</span>
            </div>
          </div>

          <div class="space-y-3">
            <div class="color-field">
              <label>Cor de Fundo</label>
              <input
                type="color"
                :value="groups.lightMode.values.backgroundColor"
                @input="updateGroupValue('lightMode', 'backgroundColor', $event.target.value)"
              />
            </div>

            <div>
              <label class="text-white text-xs block mb-1">Opacidade: {{ groups.lightMode.values.opacity }}%</label>
              <input
                type="range"
                :value="groups.lightMode.values.opacity"
                @input="updateGroupValue('lightMode', 'opacity', parseInt($event.target.value))"
                min="0"
                max="100"
                step="5"
                class="w-full"
              />
            </div>

            <div class="flex items-center justify-between">
              <label class="text-white text-xs">Inverter Logo</label>
              <button
                @click="updateGroupValue('lightMode', 'logoInvert', !groups.lightMode.values.logoInvert)"
                :class="[
                  'w-10 h-5 rounded-full transition-colors',
                  groups.lightMode.values.logoInvert ? 'bg-blue-500' : 'bg-white/20'
                ]"
              >
                <div
                  :class="[
                    'w-4 h-4 bg-white rounded-full transition-transform',
                    groups.lightMode.values.logoInvert ? 'translate-x-5' : 'translate-x-0.5'
                  ]"
                ></div>
              </button>
            </div>

            <div class="border-t border-white/10 pt-3 mt-3">
              <div class="text-white text-xs font-medium mb-2">🎨 Cores</div>
              
              <div class="space-y-2">
                <div class="color-field">
                  <label>Cor do Botão (Tipo 1)</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.buttonColorType1"
                    @input="updateGroupValue('lightMode', 'buttonColorType1', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Botão (Tipo 2)</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.buttonColorType2"
                    @input="updateGroupValue('lightMode', 'buttonColorType2', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto dos Botões</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.buttonTextColor"
                    @input="updateGroupValue('lightMode', 'buttonTextColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do texto do botão hover</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.buttonHoverColor"
                    @input="updateGroupValue('lightMode', 'buttonHoverColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.textColor"
                    @input="updateGroupValue('lightMode', 'textColor', $event.target.value)"
                  />
                </div>

                <div class="color-field">
                  <label>Cor do Texto dos Inputs</label>
                  <input
                    type="color"
                    :value="groups.lightMode.values.inputTextColor"
                    @input="updateGroupValue('lightMode', 'inputTextColor', $event.target.value)"
                  />
                </div>
              </div>
            </div>
          </div>

          <button @click="applyGroup('lightMode')" class="apply-button">
            ✓ Aplicar Grupo
          </button>
        </div>
      </div>

      <!-- Botão Aplicar Todos os Grupos -->
      <button @click="applyAllGroups" class="w-full py-3 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors mt-4">
        ✓ Aplicar Todos os Grupos Ativos
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupedConfigPanel',
  props: {
    groups: {
      type: Object,
      required: true
    },
    savedTemplates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandedGroups: {
        globalTexts: false,
        mobileLayout: false,
        tabletLayout: false,
        desktopLayout: false,
        darkMode: false,
        lightMode: false
      }
    };
  },
  methods: {
    toggleGroup(groupKey) {
      this.expandedGroups[groupKey] = !this.expandedGroups[groupKey];
    },
    toggleGroupEnabled(groupKey) {
      this.$emit('toggle-group-enabled', groupKey);
    },
    updateGroupValue(groupKey, valuePath, newValue) {
      this.$emit('update-group-value', groupKey, valuePath, newValue);
    },
    applyGroup(groupKey) {
      this.$emit('apply-group', groupKey);
    },
    applyAllGroups() {
      this.$emit('apply-all-groups');
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
.grouped-config-panel {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.group-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.group-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: white;
  transition: background 0.2s;
}

.group-header:hover {
  background: rgba(255, 255, 255, 0.05);
}

.group-content {
  padding: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
}

.apply-to-section {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.5rem;
}

.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: rgb(147, 197, 253);
  border-radius: 0.375rem;
  font-size: 0.75rem;
}

.color-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.color-field label {
  color: white;
  font-size: 0.75rem;
  flex: 1;
}

.color-field input[type="color"] {
  width: 3rem;
  height: 2rem;
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  background: transparent;
}

.apply-button {
  width: 100%;
  margin-top: 1rem;
  padding: 0.75rem;
  background: rgba(59, 130, 246, 0.8);
  color: white;
  font-weight: 500;
  border-radius: 0.5rem;
  transition: background 0.2s;
}

.apply-button:hover {
  background: rgba(59, 130, 246, 1);
}

/* Scrollbar styling */
.grouped-config-panel::-webkit-scrollbar {
  width: 6px;
}

.grouped-config-panel::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
}

.grouped-config-panel::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.grouped-config-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>
